import { ReactComponent as InjuryIcon } from '../../../../assets/icons/timeline/greenInjuryIcon.svg';
import { map } from 'lodash';
import useEventList from './useEventList';
import { eventType } from '../NewEventModal';

export default function useInjuryEvent(patientUuid: string) {
  const injuryList = useEventList(patientUuid, ['injury']);

  return map(
    injuryList ?? [],
    ({ eventTimestamp, therapistComment, uuid, affectedSide }) => ({
      name: 'Injury',
      date: eventTimestamp,
      icon: InjuryIcon,
      description: therapistComment ?? '',
      id: uuid,
      tabName: eventType.injury,
      affectedSide
    })
  );
}
